import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Button from "@/atomic/atoms/Button";
import { InputMask } from "@react-input/mask";
import { useThemeContext } from "@/contexts/ThemeContext";

export default function RegisterAvulsoView({
  goBack,
  isDisabled,
  errors,
  register,
  handleSubmit,
}: PropsView) {
  const { themeName } = useThemeContext();
  const title = themeName === 'zapay' ? 'Pedágio' : 'Dados Pessoais';

  return (
    <div className="h-full relative">
      <Header
        title={title}
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form bg-white">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={handleSubmit}>
          <div>
            <h2 className="mt-6 text-black text-xl">Vamos começar</h2>
            <div className="flex flex-col justify-center">
              <input
                {...register("name")}
                required
                type="text"
                name="name"
                placeholder="Nome completo"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.name && (
                <span className="text-red-500 text-xs">{errors.name.message as string}</span>
              )}
              <input
                {...register("email")}
                required
                type="text"
                name="email"
                placeholder="E-mail"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.email && (
                <span className="text-red-500 text-xs">{errors.email.message as string}</span>
              )}
              <InputMask
                {...register("phone")}
                required
                type="text"
                name="phone"
                inputMode="numeric"
                mask="(__) _____-____"
                replacement={{ _: /\d/ }}
                placeholder="Celular"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.phone && (
                <span className="text-red-500 text-xs">{errors.phone.message as string}</span>
              )}
            </div>
          </div>
          <Button
            className="rounded-xl bg-primary text-white"
            title="Continuar"
            type="submit"
            isDisabled={isDisabled}
          />
        </form>
      </main>
    </div>
  );
}
